import { useSyncExternalStore } from "react";

import { getSnapshot, subscribe } from "../../lib/session";

/**
 * Subscribes to the module-level session store. useSyncExternalStore rather
 * than context: the interceptors write to the store from outside React, and
 * every consumer needs to see that immediately without a provider re-render.
 */
export function useSession() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
